import React from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import ReactTooltip from 'react-tooltip';
import ItemDetails from '../../components/common/ItemDetails';
import ItemUnitOrVariants from '../../components/common/ItemUnitOrVariants';
import {ITEM_QRY, CATEGORY_QRY} from '../../common/constants.js';
import {setNoItemImage} from '../../common/utils';
import {updateStoreDataAvailability} from "../../actions/store/storeActions";
import styles from "../../css/itemCard.less";

const VariantSelectionPubSub = function() {
	this.subscribers = [];
	this.subscribe = function(subscriberCallback){
		if (subscriberCallback) {
			this.subscribers.push(subscriberCallback);
		}
	};

	this.unSubscribe = function(subscriberCallback){
		let idx = this.subscribers.indexOf(subscriberCallback);
		if (idx > -1) {
			this.subscribers.splice(idx, 1);
		}
	};

	this.publish = function(newVariantItem) {
		this.variant = newVariantItem;
		this.subscribers.forEach(sc=>sc(newVariantItem));
	};
};

class ItemCard extends React.Component {
    state = {
        variantSelectionPubSub: new VariantSelectionPubSub(),
        shouldShowQuantityUpdater: this.props.item.quantity == 0};

    openDetails = () => {
        this.props.openDetailsAction(this.props.item.key, this.props.item.category, this.props.staticData, this.props.itemsList, this.props.activeOrder);
    };

    closeDetails = () => {
        this.props.closeDetailsAction(this.props.item.category)
    };

    getItemDetails = () => {
        if(this.props.selectedItem === this.props.item.key){
            return (
                <ItemDetails item={this.props.item}
                             staticData={this.props.staticData}
                             variantsPubSub={this.state.variantSelectionPubSub}
                             clientViewPort={this.props.clientViewPort}
                             shouldShowQuantityUpdater={true}
                             closeDetails={this.closeDetails}/>
            )
        }else{
            return '';
        }
    };

    showQuantityUpdater = () => {
      this.setState({shouldShowQuantityUpdater: true});
    };

    hideQuantityUpdater = () => {
        this.setState({shouldShowQuantityUpdater: false});
    };

    render() {
        let itemClassName = "item-card";
        if(this.props.clientViewPort.isXs){
            itemClassName = "item-card-mobile row";
        }
        return (
            <div className={itemClassName} name="item-card" onMouseEnter={this.showQuantityUpdater} onMouseLeave= {this.hideQuantityUpdater}>
                <div className = {this.props.clientViewPort.isXs ? "item-image" : "" } data-tip="Click for more details">
                    <img src={this.props.item.imageUrl} onClick={this.openDetails} onError={setNoItemImage}/>
                    <ReactTooltip effect="solid" offset={{top: -50}}/>
                    {this.props.item.label && <div className="item-label">{this.props.item.label}</div>}
                </div>
                <div className="details" name="details">
                   <div className="details-top">
                       <div className="item-title" name="item-title" onClick={this.openDetails}>{this.props.item.title}</div>
                       <div className="producer-title" name="producer-title">{this.props.item.producerTitle}</div>
                   </div>
                   <ItemUnitOrVariants
                       clientViewPort={this.props.clientViewPort}
                       item={this.props.item}
                       staticData={this.props.staticData}
                       variantsPubSub={this.state.variantSelectionPubSub}
                       shouldShowQuantityUpdater={this.state.shouldShowQuantityUpdater}/>
                   </div>
                {this.getItemDetails()}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const status = (state.orderStatus || {});
    return {
        clientViewPort: (state.clientViewPort || {}),
        itemsList: state.itemsList,
        activeOrder: status.activeOrder,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        openDetailsAction: (key, category, staticData, itemsList, activeOrder) => {
            if (staticData.updateItemsAvailabilityOnCategoryChange) {
                dispatch(updateStoreDataAvailability(staticData, category, itemsList, activeOrder));
            }
            dispatch(push(location.pathname+ITEM_QRY+"="+key));
        },
        closeDetailsAction: (key) => {
            dispatch(push(location.pathname+CATEGORY_QRY+"="+key));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemCard);


// WEBPACK FOOTER //
// ./src/containers/common/ItemCard.js